import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  closeUpdateBusinessPackageModal,
  updateBusinessPackage,
} from 'state/business/actions';
import { Button, Header, Modal } from 'semantic-ui-react';

const UpdateBusinessPackageConfirmationModal = props => {
  const {
    updateBusinessPackageModal,
    allBusiness,
    selectedBusinessPackage,
    dispatch,
  } = props;

  const handleOnCancelButtonClick = () => {
    dispatch(closeUpdateBusinessPackageModal());
  };

  const handleOnOKButtonClick = () => {
    const payload = {
      businessId: allBusiness.data[allBusiness.activeIndex].id,
      package_type: selectedBusinessPackage,
    };
    dispatch(updateBusinessPackage(payload));
    dispatch(closeUpdateBusinessPackageModal());
  };

  return (
    <Modal
      closeIcon
      size="tiny"
      open={updateBusinessPackageModal}
      onClose={handleOnCancelButtonClick}
    >
      <Header icon="box" content="Update Business Package Confirm" />
      <Modal.Content>
        <p>
          Are you sure you want to change business package to{' '}
          {selectedBusinessPackage.toLowerCase()}?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={handleOnOKButtonClick}>
          OK
        </Button>
        <Button basic color="black" onClick={handleOnCancelButtonClick}>
          Cancel
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = ({ business }) => ({
  updateBusinessPackageModal: business.updateBusinessPackageModal,
  allBusiness: business.allBusiness,
  selectedBusinessPackage: business.selectedBusinessPackage,
});

UpdateBusinessPackageConfirmationModal.propTypes = {
  updateBusinessPackageModal: PropTypes.bool.isRequired,
  allBusiness: PropTypes.object.isRequired,
  selectedBusinessPackage: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(UpdateBusinessPackageConfirmationModal);
